import { Radio, FormControlLabel } from '@mui/material'
import React from 'react'

const RadioboxItem = React.memo(({shouldChecked, ele, qua, onChange}) => {
	const label = ele.title === qua?.title
		? "Do not specify Course Unit"
		: `${ele.title} ${ele.code ? `(${ele.code})` : ""}`

	return (
		<FormControlLabel
			control={<Radio id={ele._id} value={`${ele.title}_id:${ele._id}`} checked={shouldChecked} />}
			label={label}
			onChange={(e) => onChange(e)}
		/>
	)
})

export default RadioboxItem